<template>
	<div class="callout-info">
		<section class="callout-info__header">
			<el-link icon="el-icon-back" type="text" :underline="false" @click="onBack">返回</el-link>
			<el-divider direction="vertical"></el-divider>
			<span class="title">{{$route.query.type == 'edit' ? '编辑数据' : '数据详情'}}</span>
		</section>
		<section class="callout-info__container">
			<div class="callout-info__detail">
				<el-descriptions title="外呼数据" :column="1"  border>
				    <template slot="extra">
						<el-button @click.stop="getNextTaskCopy({subjectId: obj.subjectId, taskId: obj.taskId})" :disabled="$route.query.type == 'details'" type="primary" size="small">下一条任务</el-button>
						<el-divider direction="vertical"></el-divider>
						<el-dropdown  @command="handleCommand"  trigger="click">
						  <el-button type="primary" size="small" icon="el-icon-phone"
						  :disabled="obj.isFinish == 1 || $route.query.type == 'details'" @click="onCallout">执行任务<i class="el-icon-arrow-down el-icon--right"></i></el-button>
						  <el-dropdown-menu slot="dropdown">
						     <el-dropdown-item :command="item.value" v-for="(item,index) in phoneList" :key="index">{{item.name}}</el-dropdown-item>
						  </el-dropdown-menu>
						</el-dropdown>
				      
				    </template>
				    <el-descriptions-item :label="item.originalColumnName"  label-class-name="my-label" 
					:content-class-name="item.editable ? 'my-content-noborder' : 'my-content'" v-for="(item,index) in colums" :key="index">
						<div class="callout-info__origin">
							<span v-if="isImage(item.originalColumnCode)">
								<el-button @click="viewImage(colums_data[item.originalColumnCode])" type="text">查看图片</el-button>
							</span>
							<template v-else>
								<span class="content" v-if="!item.editable">{{colums_data[item.originalColumnCode] || '暂无'}}</span>
								<template v-else>
									<el-input v-if="getOriginType(item) == 'input'" v-model="colums_data[item.originalColumnCode]" style="height: 100%;"
									:placeholder="'请输入'+item.originalColumnName" size="mini"  @blur="autoInputChange(item)"
									:disabled="getDisabled(item)"></el-input>
									<el-select v-else v-model="colums_data[item.originalColumnCode]" style="height: 100%;"
									:placeholder="'请选择' + item.originalColumnName" @focus="getSelectLists(item)" @change="autoSelectChange(item)"
									clearable filterable>
										<el-option
										v-for="item in item.options"
										:key="item.value"
										:label="item.label"
										:value="item.label">
										</el-option>
									</el-select>
								</template>
							</template>
							<span class="tools" v-if="isCanEdit(item)">
								 <el-button type="text" size="mini" :disabled="$route.query.type == 'details'" @click="onEditOrigin(item)" v-if="!item.editable">编辑</el-button>
								 <template v-else>
									 <el-button type="text" size="mini" @click="onSaveOrigin(item)">保存</el-button>
									 <el-button type="text" size="mini" @click="onCancleOrigin(item)">取消</el-button>
								 </template>
							</span>
							
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-tabs v-model="activeName" style="margin-top: 10px;">
					<el-tab-pane label="客户信息" name="InfoForm"></el-tab-pane>
					<el-tab-pane label="沟通小结" name="Summary" :disabled="is_callout"></el-tab-pane>
					<el-tab-pane label="沟通历史" name="History"></el-tab-pane>
					<!-- <el-tab-pane label="变更记录" name="Log"></el-tab-pane> -->
					<el-tab-pane label="回访历史" name="calloutHistory"></el-tab-pane>
					<!-- <el-tab-pane label="订单列表" name="orderList"></el-tab-pane> -->
					<el-tab-pane :label="item.tabName" :name="item.tabId" v-for="(item, index) in tabList" :key="index">
						<Table v-if="activeName == item.tabId" :item="item" :customerId="customerId" />
					</el-tab-pane>
				</el-tabs>
				<InfoForm :customerId="customerId"  v-if="activeName === 'InfoForm'" />
				<Summary :customerId="customerId" :tuId="callout_id" v-if="activeName === 'Summary'" />
				<History :customerId="customerId" v-if="activeName === 'History'" />
				<!-- <Log :customerId="customerId" v-if="activeName === 'Log'" /> -->
				<CalloutHistory :custId="customerId" v-if="activeName === 'calloutHistory'" />
				<!-- <OrderList :custId="customerId" v-if="activeName === 'orderList'" /> -->
			</div>
			<div class="callout-info__questionnaire">
				<div class="header">
					<span>外呼问卷</span>
					<h1>{{paperInfos.formInfo.paperName}}</h1>
				</div>
				<div class="content">
					<FormPreview @updateResult="updateResult"  :formData="paperInfos"  v-if="paperInfos.formDesign.length > 0" sourceType="CallOut" :realResultList="real_results"/>
				</div>
				<div class="footer">
					<el-button type="primary" size="small" @click="onSavePaper" v-if="$route.query.type == 'edit'">保存问卷</el-button>
					<el-button type="primary" size="small" @click="onFinish" :disabled="obj.isFinish == 1 || $route.query.type == 'details'" v-else>完成外呼</el-button>
				</div>
			</div>
		</section>
		<FinishCallout ref="finishCallout" :obCount="obCount" :obTimes="obTimes" :createTime="createTime" :callout_id="callout_id" @getNextTask="getNextTask" :paperName="paperInfos.formInfo.paperName"/>
		<el-dialog
		   title="执行外呼"
		   :visible.sync="callout_dialog_visible"
		   width="500px" >
		  <el-input type="text" :value="calloutPhone.name" disabled/>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="callout_dialog_visible = false">取 消</el-button>
		    <el-button :disabled="isDisabled" type="primary" @click="toRealCallout()">立即拨打</el-button>
			<el-button :disabled="isDisabled" @click="toRealCallout('other')" type="primary" v-show="calloutPhone.type">立即拨打(外地)</el-button>
		  </span>
		</el-dialog>

		<el-image-viewer 
			v-if="imgViewerVisible" 
			:on-close="closeImgViewer" 
			:url-list="imgList" />

	</div>
</template>

<script>
	import { mapGetters,mapState, mapMutations } from 'vuex';
	import InfoForm from "@/components/CustomerInfo/info";
	import Summary from "@/components/CustomerInfo/summary";
	import History from "@/components/CustomerInfo/history";
	import Log from "@/components/CustomerInfo/log";
	import Table from "@/components/CustomerInfo/table";
	import CalloutHistory from "./history.vue";
	import FormPreview from "@/components/SurveyDesign/components/FormPreview";
	import FinishCallout from './finish.vue';
	// import OrderList from "./orderList.vue";
	import { sipInit } from '@/components/Softphone/jsSipFun';
	import { hidePhone } from '@/utils/functions';
	import {tagviewsMixins} from '@/utils/mixins.js';
	import { getTableColumn} from '@/api/manange';
	export default {
		mixins:[tagviewsMixins],
		computed: {
		    ...mapGetters([
				'userInfo',
				'StoreIsSignIn', // ~ 是否签入
				'StoreIsBusy', // ~ 是否置忙
				'StoreIsBusyReason', // ~ 置闲 / 置忙原因
				'StoreIsBusyReasonList',
				'StoreTuId',
				'StoreCallout'
		    ]),
			...mapState({
				visitedViews:state => state.tagsView.visitedViews
			})
		},
		components: {
			InfoForm,
			Summary,
			History,
			Log,
			CalloutHistory,
			FormPreview,
			FinishCallout,
			Table,
			'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
			// OrderList
		},
		data() {
			return {
				obCount: '',
				obTimes: '',
				createTime: '',
				is_callout:true,
				callout_id:'',
				timer:null,
				activeName:'InfoForm',
				batchNum:'',
				colums:[],
				colums_data:'',
				colums_catch_data:'',
				paperInfos:{
					formInfo: {},//问卷信息
					formDesign: [],//题数组
					formSelect: {},
				},//问卷组件参数
				customerId:'',
				tuId:'',
				obj:{
					paperId:'',
					originalId:'',
					taskId:'',
					paperSaveId:'',
					custId:'',
					contactPlanId:'',
					subjectId:'',
					campaignId:'',
					isFinish:'0',
					userId:'',
					userAccount:'',
					incidentId:'',//沟通id
					virtualPhoneNumberUrl:''
				},
				pager:{
					resultList:[],
					questions:{}
				},//问卷答题结果
				real_results:[],//获取问卷结果
				phoneList:[],
				callout_dialog_visible:false,
				calloutPhone:{
					value:'',
					name:''
				},
				brandName:process.env.VUE_APP_BRANDNAME,
				editLists:[
					{name:'姓名',type:'input'},
					{name:'性别',type:'select'},
					// {name:'车型',type:'select'},
					{name:'购车时间',type:'select'},
					{name:'城市名称',type:'select'},
					{name:'意向级别',type:'select'},
					{name:'计划购车时间',type:'select'},
					{name:'购车预算',type:'select'},
					{name:'是否添加微信',type:'select'},
					{name:'门店',type:'select'},
					{name:'孵化中心名称',type:'select'},
					{name:'微信手机号',type:'input'},
					{name:'备用电话',type:'input'},
					{name:'预留问题',type:'input'},
					{name:'门店名称',type:'select'},	
					{name:'购车城市名称',type:'select'},
				],
				autoSaves:[
					{code:'c_chengshicode',name:'城市code',p_name:'城市名称'},
					{code:'c_mendianbianma',name:'门店编码',p_name:'门店名称'},
					{code:'c_fuhuazhongxinbianma',name:'孵化中心编码',p_name:'孵化中心名称'},
					{code:'c_gouchechengshibianma',name:'购车城市编码',p_name:'购车城市名称'},
					{code:'c_weixinshoujihao',name:'微信手机号',p_name:'是否添加微信'},
					{code:'c_shipitianjiaweishen',name:'是否添加微信',p_name:'微信手机号'}
				],
				pageNumber: 1,
				isDisabled: false,
				tabList: [],
				channelIdentify: '',
				imgViewerVisible: false, // 图片查看器显示状态
			}
		},
		methods: {
			getTabList() {
				this.$api.apiGetTabList({channel: this.channelIdentify || ''}).then(response => {
					if(response.errcode != 0) return;
					this.tabList = response?.data || [];
				});
			},
			getDisabled(row){
				if(row.originalColumnName == '微信手机号'){
					return !this.colums_data['c_shipitianjiaweishen'] || this.colums_data['c_shipitianjiaweishen'] == '否'
				}
				return false;
				
			},
			setCalloutNumber(){
				this.$api.getCalloutNumber({
					taskId:this.obj.taskId,
					brandIdentify:this.userInfo.brandIdentify
				}).then(res => {
					this.obCount++;
				})
			},
			getSelectLists(row){
				getTableColumn({
					pageNumber:1,
					pageSize:10000,
					columnName:row.originalColumnName.indexOf('城市名称') > -1 ? '城市名称' : row.originalColumnName,
					brand:this.userInfo.brandIdentify
				}).then(res => {
					if(res.errcode != 0) return;
					if(res.data.length == 0) return;
					let result = res.data[0].optionsJson ? JSON.parse(res.data[0].optionsJson) : '';
					if(!result) return;
					this.$set(row,'options',result.data);
				})
			},
			onEditOrigin(row){
				this.$set(row,'editable',true);
			},
			onCancleOrigin(row){
				this.$set(row,'editable',false);
				this.colums_data = JSON.parse(JSON.stringify(this.colums_catch_data))
			},
			isNumber(str){
				return /^[0-9]*$/.test(str);
			},
			onSaveOrigin(row){
				// if(!this.colums_data[row.originalColumnCode]){
				// 	 this.$message.error(`${[row.originalColumnName]}不能为空`);
				// 	 return;
				// }
				if((row.originalColumnName == '微信手机号' || row.originalColumnName == '备用电话') && this.colums_data[row.originalColumnCode]) {
					if(!this.isNumber((this.colums_data[row.originalColumnCode])) || this.colums_data[row.originalColumnCode].length > 25) {
						this.$message.error(`${[row.originalColumnName]}只允许为数字且长度不可超过25位`);
						return;
					}
				}
				this.$api.updateBreathdataBaseColumnList({
					batchNum:this.colums_data['batch_num'],
					brandIdentify:this.userInfo.brandIdentify,
					columnCode:row.originalColumnCode,
					columnValue:this.colums_data[row.originalColumnCode] || '',
					originalId:this.colums_data['original_id']
				}).then(res => {
					if(res.errcode != 0) return;
					this.$set(row,'editable',false);
					let index = this.autoSaves.findIndex(el => el.p_name == row.originalColumnName);
					if(index != -1){
						this.$api.updateBreathdataBaseColumnList({
							batchNum:this.colums_data['batch_num'],
							brandIdentify:this.userInfo.brandIdentify,
							columnCode:this.autoSaves[index]['code'],
							columnValue:this.colums_data[this.autoSaves[index]['code']] || '',
							originalId:this.colums_data['original_id']
						}).then(response => {
							if(res.errcode != 0) return;
							this.$message.success('保存成功');
							this.getColumnsData();
						})
					}else {
						this.$message.success('保存成功');
						this.getColumnsData();
					}
				})
			},
			autoInputChange(row){
				if(row.originalColumnName == '微信手机号'){
					if(this.colums_data[row.originalColumnCode]){
						this.$set(this.colums_data,'c_shipitianjiaweishen', '是');
					}else {
						this.$set(this.colums_data,'c_shipitianjiaweishen', '否');
					}
					return
				}
			},
			autoSelectChange(row){
				let index = this.autoSaves.findIndex(el => el.p_name == row.originalColumnName);
				if(index == -1) return;
				let code_index = row.options.findIndex(el => el.label == this.colums_data[row.originalColumnCode]);
				if(code_index == -1){
					this.$set(this.colums_data,this.autoSaves[index]['code'], '');
					return;
				}
				if(row.originalColumnName == '是否添加微信'){
					if(row.options[code_index].label == '否') return this.$set(this.colums_data,this.autoSaves[index]['code'], '');
					return 
				}
				this.$set(this.colums_data,this.autoSaves[index]['code'],row.options[code_index].value);
			},
			getOriginType(row){
				if(!row.originalColumnName) return 'input';
				let index = this.editLists.findIndex(el => el.name == row.originalColumnName);
				if(index != -1) return this.editLists[index].type;
				return 'input';
			},
			isCanEdit(row){
				if(this.userInfo.brandIdentify != this.brandName) return false;
				if(!row.originalColumnName) return false;
				let index = this.editLists.findIndex(el => el.name == row.originalColumnName);
				if(index != -1) return true;
				return false;
			},
			updateResult(data){
				if(data) {
					this.pager = data;
				}
			},
			onFinish(){
				// if(!this.obj.paperSaveId){
				// 	// this.$message.error('请先保存问卷');
				// 	this.onSavePaper();
				// 	return;
				// }
				this.onSavePaper();
				// this.$refs.finishCallout.onShow(this.obj)
			},
			getNextTask(data){
				this.$api.toAutoTaskBreathTask({
					 subjectId:data.subjectId,
					 brandIdentify:this.$store.getters.userInfo.brandIdentify,
				}).then(res => {
					if(res.errcode != 0) return;
					if(res.data.message == 'Empty task'){
						this.$notify.error('该主题下没有可执行的外呼任务');
						setTimeout(()=> {
							this.onBack();
						},1000);
						return;
					}
					this.$notify.success('已成功切换下一个外呼任务');
					this.closeTab(this.$route.path);
					this.$router.push({
						path:`/breathe/callOut/info/${res.data.obTask.taskId}`
					})
				})
			},
			getNextTaskCopy(data){
				let pageNumber = this.$route.query?.pageNumber ? Number(this.$route.query?.pageNumber) + 1 : 2;
				this.$api.toAutoTaskBreathTask({
					taskId: data.taskId,
					subjectId: data.subjectId,
					brandIdentify: this.$store.getters.userInfo.brandIdentify,
					pageNumber: pageNumber
				}).then(res => {
					if(res.errcode != 0) return;
					if(res.data.message == 'Empty task'){
						this.$notify.error('该主题下没有可执行的外呼任务');
						return;
					}
					this.pageNumber++;
					this.$notify.success('已成功切换下一个外呼任务');
					this.closeTab(this.$route.path);
					this.$router.push({
						path:`/breathe/callOut/info/${res.data.obTask.taskId}?pageNumber=${pageNumber}`
					})
				})
			},
			onSavePaper(){
				if(this.pager.resultList.length > 0){
					let lists = this.sortObjArr(this.pager.resultList);
					let u_list = this.getUnique(lists);
					let paper = {
						saveId:this.obj.paperSaveId,
						paperId:this.obj.paperId,
						paperStartTime:new Date().getTime(),
						custId:this.customerId,
						taskId:this.obj.taskId,
						brandId:this.$store.getters.userInfo.brandIdentify
					};
					let results = this.getPagerParams(u_list);
					this.$api.apiSaveSurveyPaper({
						paper: JSON.stringify(paper),
						results:JSON.stringify(results)
					}).then(res => {
						if(res.errcode != 0) return;
						this.obj.paperSaveId = res.data.saveId;
						this.$message.success('保存问卷成功');
						if(this.$route.query.type != 'edit'){
							this.$refs.finishCallout.onShow(Object.assign(this.obj,this.colums_data));
						}
					})
				}else {
					// this.$message.error('请先答问卷');
					if(this.$route.query.type != 'edit'){
						this.$refs.finishCallout.onShow(Object.assign(this.obj,this.colums_data));
					}
				}
			},
			handleCommand(command){
				let isChrome = window.navigator.userAgent.indexOf("Chrome") > -1;
				this.sipDriver = sipInit();
				if(!isChrome) {
					this.$message.error('仅支持在Chrome浏览器85版本及以上使用');
					return;
				}
				if(this.StoreIsSignIn && this.StoreIsBusy && this.StoreIsBusyReasonList.includes(this.StoreIsBusyReason) && command) {
					if(this.obj.virtualPhoneNumberUrl){
						this.$api.getVirtualPhoneNumberUrl(this.obj.virtualPhoneNumberUrl,{realPhone:command, taskId: this.obj.taskId}).then(res => {
							if(res.errcode != 0) return;
							this.getPhoneArea(res.data)
						})
					}else{
						this.getPhoneArea(command)
					}
					
					
				} else {
					this.$message.error('请将软电话设置为置忙 - 外呼');
				}
			},
			getPhoneArea(command){
				if(/^1[3456789]\d{9}$/.test(command)) {
					this.$api.apiPostSelectForeign({
						phoneNumber: command,
						landlineNumber: this.$store.getters?.StoreAgentInfo.calleridText,
					}).then(res => {
						this.isDisabled = false;
						this.callout_dialog_visible = true;
						if(res.errcode != 0) {
							this.calloutPhone = {
								name:hidePhone(command),
								value:command,
								type:'other'
							}
						}else{
							this.calloutPhone = {
								name:hidePhone(command),
								value:res.data ? ('0' + command) : command,
							}
						}
					}).catch(err => {
						this.isDisabled = false;
						this.callout_dialog_visible = true;
						this.calloutPhone = {
							name:hidePhone(command),
							value:command,
							type:'other'
						}
					})
				} else {
					this.isDisabled = false;
					this.callout_dialog_visible = true;
					this.calloutPhone = {
						name:hidePhone(command),
						value: command,
						type:'other'
					}
				}
				
			},
			toRealCallout(type){
				this.isDisabled = true;
				if(type){
					this.calloutPhone.value = '0' + this.calloutPhone.value;
				}
				this.callout_dialog_visible = false;
				this.$store.commit('telService/SET_IS_CALL', true);
				this.sipDriver._call(this.calloutPhone.value, {
					brandId: this.userInfo.brandIdentify,
					channelId: 'phone',
					direction: 'OB',
					callingNumber: this.userInfo.deviceCode,
					calledNumber: this.calloutPhone.value,
					custId: this.customerId,
					custName: this.colums_data.c_xingmingshili,
					csrUserId: this.obj.userId,
					pkValue: this.obj.taskId,
					csrUserName: this.obj.account,
					startTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
				}, '*5');
				this.is_callout = false;
				this.setCalloutNumber();//新增外呼次数
				this.getCalloutId();
				
			},
			getCalloutId(){
				let count = 0;
				this.timer = setInterval(()=>{
					count++;
					this.$api.apiPostCommunicateList({
						pageSize: 1,
						pageNumber: 1,
						brandId: this.userInfo.brandIdentify,
						searchType: '',
						subBrandId: '',
						channelId: '',
						createdAfter: '',
						createdBefore: '',
						tuid: '',
						csrUserId: this.customerId,
						direction: 'OB',
						callingNumber: '',
						custName: ''
					}).then(res => {
						if(res.errcode != 0){
							clearInterval(this.timer);
							return;
						}
						if(res.data && res.data.length > 0){
							let time = res.data[0]?.startTime || res.data[0]?.createdText;
							time = new Date(time).getTime() / 1000;
							let now = new Date().getTime() / 1000;
							if(now - time < 30){
								this.callout_id = res.data[0]?.tuid;
								this.is_callout = false;
								clearInterval(this.timer);
							}else if(count > 5){
								clearInterval(this.timer);
							}
							
						}
					}).catch(() => {
						clearInterval(this.timer);
					})
				},2000)
			},
			onCallout(){
				this.$api.apiPostCustomerInfo({
					brand: this.userInfo.brandIdentify,
					customerId: this.customerId}).then(res => {
						if(res.errcode != 0) return;
						let results = [res.data[0].phoneNumber,res.data[0].phoneNumber1,res.data[0].phoneNumber2];
						this.phoneList = [];
						results.map(item => {
							if(item){
								this.phoneList.push({
									name:hidePhone(item),
									value:item
								})
							}
						})
				})
			},
			onBack(){
				 this.closeTab(this.$route.path);
				 this.$router.go(-1)
			},
			getColums(){
				this.$api.getBreathdataBaseColumnList({
					brandIdentify:this.$store.getters.userInfo.brandIdentify,
					batchNum:this.batchNum
				}).then(res => {
					if(res.errcode != 0) return;
					this.colums = res.data.filter(el => el.isNotShow != 1);
				})
			},
			getColumnsData(){
				this.$api.getTaskBreathTaskInfos({
					brandIdentify:this.$store.getters.userInfo.brandIdentify,
					batchNum:this.batchNum,
					originalId:this.obj.originalId
				}).then(res => {
					if(res.errcode != 0) return;
					this.colums_data = res.data.obOriginal;
					this.colums_catch_data = JSON.parse(JSON.stringify(res.data.obOriginal));
				})
			},
			getPaperInfos(){
				this.$api.apiGetSurveyPaperInfo({
					paperId: this.obj.paperId
				}).then(res => {
					if(res.errcode != 0) return;
					if(this.obj.paperSaveId){
						this.getPaperResults(res);
					}else {
						this.paperInfos = {
							formInfo: res.data.surveyPaper,
							formDesign:res.data.surveyQuestionList,
							formSelect: {},
						};
					}
				})
			},
			getPagerParams(lists){
				let results = [];
				let itemIds = [];
				let values = '';
				lists.map(item => {
					if(Array.isArray(this.pager.questions[item.questionCode]) && this.pager.questions[item.questionCode].length > 0){
						itemIds = item.itemList.filter(v => this.pager.questions[item.questionCode].includes(v.itemCode));
						values = this.pager.questions[item.questionCode].join(',')
					}else {
						itemIds = item.itemList.filter((el) => el.itemCode == this.pager.questions[item.questionCode]);
						values = this.pager.questions[item.questionCode]
					}
					results.push({
						questionId:item.questionId,
						itemId:this.getFixedValue(itemIds,'itemId'),
						value:values,
						text:this.getFixedValue(itemIds,'defaultValue')
					})
				})
				return results;
			},
			getFixedValue(arr,key){
				let results = [];
				arr.map(item => {
					results.push(item[key])
				})
				results = results.length > 0 ? results.join(',') : '';
				return results;
			},
			getUnique(arr){
				let cache = [];
				for (let item of arr) {
					if (cache.find(v => v.questionId == item[0].questionId)) {
						continue
					}
					cache.push(item[0])
				}
				return cache
			},
			sortObjArr(objArr){
				var arr = [];
				for(let i in objArr) {
					arr.push([objArr[i],i])
				}
				arr.reverse();
				return arr;
			},
			getInfos(){
				let params = {
					brandIdentify:this.$store.getters.userInfo.brandIdentify,
					isDetail: this.$route.query.type == 'details' ? 1 : null
				}
				if(this.obj.subjectId){
					params.subjectId = this.obj.subjectId
				}else {
					params.taskId = this.obj.taskId;
				}
				this.$api.toAutoTaskBreathTask(params).then(res => {
					if(res.errcode != 0) return;
					if(res.data.message == 'Empty task'){
						this.$notify.error('该主题下没有可执行的外呼任务');
						setTimeout(()=> {
							this.onBack();
						},1000);
						return
					}
					this.$store.commit('app/SET_VIRTUAL_HOST', res.data?.obTask?.virtualPhoneNumberUrl);
					Object.keys(this.obj).map(item => {
						this.obj[item] = res.data.obTask[item];
					})
					console.log(res)
					this.obCount = Number(res.data.obTask.obTimes);
					this.createTime = res.data.obTask.createTime;
					this.obTimes = res.data.obTask.obTimes;
					this.customerId = res.data.obTask.custId;
					this.channelIdentify = res.data.obTask.channelIdentify
					this.tuId = res.data.obTask.contactPlanId;
					this.batchNum = res.data.obTask.originalBatchNum;
					this.getColums();
					this.getColumnsData();
					this.getPaperInfos();
					this.getTabList();
				})
			},
			getPaperResults(originData){
				this.$api.apigetSurveyPaperResult({
					saveId:this.obj.paperSaveId
				}).then(res => {
					if(res.errcode != 0) return;
					this.paperInfos = {
						formInfo: originData.data.surveyPaper,
						formDesign:originData.data.surveyQuestionList,
						formSelect: {},
					};
					this.real_results = this.formatPaperResultl(res.data);
				})
			},
			formatPaperResultl(data){
				let paperLists = JSON.parse(JSON.stringify(this.paperInfos.formDesign));
				paperLists.map(item => {
					data.map(_item => {
						if(item.questionId == _item.questionId) {
							item.defaultValue = item.questionType == 2 ? _item.itemCode.split(',') : _item.itemCode;
							item.operateType = 'show';
							item.itemList.map(_sub => {
								if(_sub.itemId == _item.itemId){
									if(_item.itemText){
										if(item.questionType == 2 ){
											for(let k of _item.itemText.split(',')){
												_sub.defaultValue = k;
											}
										}else {
											_sub.defaultValue = _item.itemText;
										}
									}
								}else {
									if(item.questionType == 2){
										let ids = _item.itemId ? _item.itemId.split(',') : [];
										for(let j in ids){
											if(_sub.itemId == ids[j]){
												_sub.defaultValue = _item.itemText ? _item.itemText.split(',')[j] : '';
											}
										}
									}
									
								}
							})
						}
					})
				})
				return paperLists;
			},
			// 查看图片
			viewImage(imageName) {
				console.log("查看图片:",imageName);
				this.imgList = [`${process.env.VUE_APP_BASE_API}/file/call/ferrari/`+imageName];
				this.imgViewerVisible = true;
			},
			closeImgViewer() {
				this.imgViewerVisible = false;
			},
			isImage(key) {
				return /_image$/.test(key)
			}
		},
		created(){
			if(this.$route.query.type == 'subject_id'){ //执行外呼页面跳转
				this.obj.subjectId = this.$route.params.id;
			}else {
				this.obj.taskId = this.$route.params.id;
			}
			this.getInfos();

		},
		destroyed() {
			clearInterval(this.timer);
		}
	}
</script>

<style lang="scss" scoped>
	.callout-info {
		width: 100%;
		height: 100%;
		overflow: hidden;
		padding: 5px 10px;
		&__header {
			width: 100%;
			height: 40px;
			line-height: 40px;
			padding: 0 5px;
			
			& .el-link {
				vertical-align: top;
				color: #303133;
			}
			
			& .el-divider {
				vertical-align: top;
				margin-top: 13px;
			}
			
			& > .title {
				font-size: 14px;
				font-weight: bold;
				color: #303133;
				vertical-align: top;
				letter-spacing: .5px;
			}
		}
			
		&__container {
			width: 100%;
			height: calc(100% - 40px);
			overflow: hidden;
			display: flex;
			justify-content: space-between;
		}
		&__detail {
			width: 500px;
			height: 100%;
			border: 1px solid #CCC;
			overflow-y: auto;
			padding: 20px;
			::v-deep {
				.my-label {
					display: inline-block;
					width: 150px;
				}
				.my-content,.my-content-noborder {
					display: inline-block;
					width: calc(100% - 150px);
				}
				.my-content-noborder {
					border: none;
				}
				.el-button--text {
					padding: 0;
				}
			}
		}
		&__origin {
			display: flex;
			justify-content: space-between;
			align-items: center;
			.tools {
				width: 80px;
				text-align: right;
			}
		}
		
		&__questionnaire {
			width:calc(100% - 500px - 10px);
			height: 100%;
			border: 1px solid #CCC;
			overflow-y: auto;
			padding: 10px;
			box-sizing: border-box;
			.header {
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 14px;
				height: 30px;
				position: relative;
				span {
					position: absolute;
					left: 10px;
				}
				h1 {
					font-weight: normal;
					font-size: 14px;
				}
			}
			.content {
				margin: 20px 0;
				height: calc(100% - 30px - 50px - 40px);
				overflow: auto;
			}
			.footer {
				display: flex;
				justify-content: center;
				align-items: center;
				height: 50px;
			}
		}
	}
</style>
